import {useEffect, useState} from "react";

export const useDebouncedViewportWidth = (debounceMs = 150) => {
    const [width, setWidth] = useState(() =>
        typeof window !== "undefined" ? window.innerWidth : 0,
    );

    useEffect(() => {
        let timer = null;
        const onResize = () => {
            if (timer != null) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                timer = null;
                setWidth(window.innerWidth);
            }, debounceMs);
        };

        window.addEventListener("resize", onResize, {passive: true});
        return () => {
            if (timer != null) {
                clearTimeout(timer);
            }
            window.removeEventListener("resize", onResize);
        };
    }, [debounceMs]);

    return width;
};
